// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__3HHvF","compareProductsHeader":"styles_compareProductsHeader__3kaoU","addedProduct":"styles_addedProduct__1BwyI","limitReach":"styles_limitReach__1FR1S"};